import * as actions from './endgame.actions'

const initialState = {
  report: {},
}

const actionsMap = {
  [actions.SET_REPORT_DATA]: (state, action) => {
    return {
      ...state,
      report: action.data,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
